
import { MessageSquare } from "lucide-react";
import { type TranslationKey } from "@/utils/translations";

interface EmptyChatsProps {
  t: Record<TranslationKey, string>;
}

export const EmptyChats = ({ t }: EmptyChatsProps) => {
  return (
    <div className="text-center py-16 max-w-md mx-auto">
      <div className="bg-primary/10 rounded-full p-4 w-20 h-20 mx-auto mb-6 flex items-center justify-center">
        <MessageSquare className="w-10 h-10 text-primary" />
      </div>
      <h3 className="text-xl font-semibold text-navy mb-3">
        No tienes conversaciones guardadas
      </h3>
      <p className="text-coolGray leading-relaxed">
        Cuando tengas conversaciones con nuestro asistente, aparecerán aquí para que puedas revisarlas más tarde.
      </p>
    </div>
  );
};
